import React from "react";
import { IDataFragment } from "core/components/FragmentProvider";
import styled from "styled-components";
import Label from "core/components/label/Label";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import { InputVariant, InputView } from "common/views/input/Input.view";
import { DatePickerWidget } from "common/form/widgets/date/DatePickerWidget";
import { IAssignmentFragmentProps } from "../TestAssignmentList.panel";
import IOption from "common/models/IOption";
import { TextArea } from "@blueprintjs/core/lib/esm/components/forms/textArea";
import { Lifecycle } from "../entities/TestAssignment";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import ServiceRegistry from "core/util/ServiceRegistry";
import XHRResolverService from "core/service/resolver/impl/XHRResolver.service";
import { ForumToaster } from "panels/forum/forumActions";
import { Intent } from "@blueprintjs/core/lib/esm/common";
import { iDef } from "core/util/TypeUtils";
import { Icon } from "@blueprintjs/core/lib/esm/components/icon/icon";

const StyledDiv = styled.div`
	 {
		padding: 0.5em;
		//width: 50%;
		& > span > input{
			//flex: 2;
		}
		& > span > span{
			width:100%
		}
		& > span > svg{
			width: 8px;
			color: red;
		}
		& > input{
			width:100%
		}
		& > div > span > span > button {
			//flex: 1;
			min-width: 312px;
		}
	}
`;

const getValue = (state:any, entity:any , name:string) => {
	if (iDef(entity.name))
		return entity.name;
	
	return state.name;
}

export const institution: IDataFragment<IAssignmentFragmentProps> = {
	name: "institution",
	label: {},
	component: ({ onInstChange, state, edit }) => {
    
        return (
			<React.Fragment>
				<StyledDiv>
                <Label k={"institution"} v={"Institution"} /> <Icon icon="asterisk" /> <br />
				<DropdownSelect
                        options={
							(state.institutions || []).map<IOption<string>>((ct) => ({
								value: ct.guid,
								label: ct.name
							}))
						}
                        value={state.instId}
                        onChange={val=>{onInstChange(val.toString())}}
						disabled={edit}
                    /> <br />
				</StyledDiv>
            </React.Fragment>
        )
    }
};

export const program: IDataFragment<IAssignmentFragmentProps> = {
	name: "program",
	label: {},
	component: ({ onProgramChange, state, edit}) => {
    
        return (
			<React.Fragment>
				<StyledDiv>
				<Label k={"program"} v={"Program"} /> <Icon icon="asterisk" /> <br />
                    <DropdownSelect
                        options={
							(state.programs || []).map<IOption<string>>((ct) => ({
								value: ct.id.toString(),
								label: ct.name
							}))
						}
                        value={state.programId.toString()}
                        onChange={val=>{onProgramChange(Number.parseInt(val))}}
						disabled={edit}
                    /> <br />
				</StyledDiv>
            </React.Fragment>
        )
    }
};

export const name: IDataFragment<IAssignmentFragmentProps> = {
	name: "name",
	label: {},
	component: ({ onChange, state }) => {
		return (
			<React.Fragment>
				<StyledDiv>
					<Label k={"name"} v={"Name"} /> <Icon icon="asterisk" /> <br />
					<InputView
						viewKey={"name"}
						name={"name"}
						value={state.properties["name"] && state.properties["name"]}
						onChange={ev=>{onChange("name", ev.target.value)}}
						variant={InputVariant.TEXT}
					/> <br /> <br />
				</StyledDiv>
			</React.Fragment>

		);
	}
};

export const description: IDataFragment<IAssignmentFragmentProps> = {
	name: "description",
	label: {},
	component: ({ onChange, state }) => {
		return (
			<React.Fragment>
				<StyledDiv>
					<Label k={"description"} v={"Description"} /> <br />
					<TextArea
							large={true}
							value={state.properties["description"] && state.properties["description"]}
							onChange={ev=>{onChange("description", ev.target.value)}}
							style={{width: "30%"}}
							fill={true}
						/> <br />
				</StyledDiv>
			</React.Fragment>

		);
	}
};

export const startDate: IDataFragment<IAssignmentFragmentProps> = {
	name: "startDate",
	label: {},
	component: ({ onChange, state }) => {
		return (
			<React.Fragment>
				<StyledDiv>
					<Label k={"startDate"} v={"Start Date"} /> <Icon icon="asterisk" /> <br />
					<DatePickerWidget 
						value={state.properties["startDate"] && state.properties["startDate"]}
						onChange={(v)=> {onChange("startDate", v)}} 
						required={true}
						maxDate={(()=> {
							let d =new Date();
							d.setFullYear(d.getFullYear() + 5);
							return d;
						})()} 
                    /> 
					<br /> <br />
				</StyledDiv>
			</React.Fragment>

		);
	}
};

export const endDate: IDataFragment<IAssignmentFragmentProps> = {
	name: "endDate",
	label: {},
	component: ({ onChange, state }) => {
		return (
			<React.Fragment>
				<StyledDiv>
					<Label k={"endDate"} v={"End Date"} /> <Icon icon="asterisk" /> <br />
					<DatePickerWidget 
						value={state.properties["dueDate"] && state.properties["dueDate"]}
						onChange={(v)=> {onChange("dueDate", v)}} 
						required={true} 
						maxDate={(()=> {
							let d =new Date();
							d.setFullYear(d.getFullYear() + 5);
							return d;
						})()}/> 
						<br /> <br />
				</StyledDiv>
			</React.Fragment>

		);
	}
};

export const status: IDataFragment<IAssignmentFragmentProps> = {
	name: "status",
	label: {},
	component: ({ state }) => {
		return (
			<React.Fragment>
				<StyledDiv>
					<Label k={"status"} v={"Status"} /> <Icon icon="asterisk" /> <br />
					<InputView
						viewKey={"status"}
						name={"status"}
						variant={InputVariant.TEXT}
						value={Lifecycle[state.properties["assignmentStatus"]]}
						disabled={true}
					/> <br /> <br />
				</StyledDiv>
			</React.Fragment>

		);
	}
};

export const submit: IDataFragment<IAssignmentFragmentProps> = {
	name: "submit",
	label: {},
	component: ({ state, edit, assignmentId, onAfterCreate }) => {

		const getMutationQuery=()=>{
			let properties = {...state.properties}
			properties["institutionId"] = state.instId
			properties["programId"] = state.programId

			let params:string ;
			if (edit){
				params = "mutation { testAssignmentUpdate(params: { "
				properties["id"] = assignmentId
			} else {
				params = "mutation { testAssignmentCreate(params: { ";
			}
			
			let entries = Object.entries(properties)
			entries.map( ([key, val]) => {
				if(typeof val === "string"){
					params = params + key+":\""+val+"\", ";
				} else if(Array.isArray(val)){
					params = params + key+":["+val+"], ";
				}
				else  params = params + key+": "+val+", "; 
			  });
	
			  params= params+ " }) { entityId } } ";
			  return params;
		}

		const isNullorEmpty=(...values)=>{
			for(var i = 0; i < values.length; i++) {
				if (!values[i] || values[i] == undefined || values[i] == "" || values[i].length == 0){
					return true
				}
			  }
			  return false;	
		}

		const validateData = () => {
			let validate= true;
			let msg = "";
			if(isNullorEmpty(state.instId)) {
				msg = "Institute selection is required."
				validate=false;
			} 
			if(isNullorEmpty(state.programId)) {
				msg = "Program selection is required."
				validate=false;
			} 
			if(isNullorEmpty(state.properties['name'])) {
				msg = "Name field cannot be empty."
				validate=false;
			} 
			if(isNullorEmpty(state.properties['startDate'])) {
				msg = "Start date cannot be empty."
				validate=false;
			} 
			if(isNullorEmpty(state.properties['dueDate'])) {
				msg = "End date cannot be empty."
				validate=false;
			} 

			if (msg !== ""){
				ForumToaster.show({
					intent: Intent.DANGER,
					message: msg
				});
			}
			return validate;
		}

		const onSubmit=()=>{
			if (!validateData()){
				return;
			}

			const mutation = getMutationQuery();
			let entityId = 0;
			const req = [];
			const que = ServiceRegistry.get(XHRResolverService).execute(mutation).then(req => {
				
				let reqData= JSON.parse(req);
				let data= reqData.data;
				if(reqData.errors){
					ForumToaster.show({
						intent: Intent.DANGER,
						message: "Error While Assignment Creation"
					});
				} else if(data['testAssignmentCreate']){
					ForumToaster.show({
						intent: Intent.SUCCESS,
						message: "Assignment Creation Successful!!"
					});
					entityId = data['testAssignmentCreate']['entityId'];
				} else if(data['testAssignmentUpdate']){
					ForumToaster.show({
						intent: Intent.SUCCESS,
						message: "Assignment Updated Successfully!!"
					});
				}
			 }).catch(err => {
				console.log(err);
			 });

			 req.push(que);
             Promise.all(req)
				.then((value) => {
					if (entityId !== 0){
						onAfterCreate(entityId);
					}
				})
				.catch((reason) => {
					console.log(reason)
					ForumToaster.show({
						intent: Intent.DANGER,
						message: "An error occurred!!"
					});
				});
		}
		
		const label = edit ? "Update" : "Submit";
		const display = (edit && state.properties["assignmentStatus"] === 2) ? "none" : "block";

		return(
			
			<StyledDiv style={{display:display}}>
				<ButtonView
					variant={ButtonVariant.PRIMARY}
					viewKey="assignmentForm.submit"
					onClick={onSubmit}
				>
					<Label k="assignmentForm.submitButton" v={label}/> 
				</ButtonView>
			</StyledDiv>
		)
	}
}

export const publish: IDataFragment<IAssignmentFragmentProps> = {
	name: "publish",
	label: {},
	component: ({ state, edit, assignmentId, onChange }) => {

		const getMutationQuery=()=>{
			let params:string = "mutation { testAssignmentPublish(params: { ";
			params = params + "id: "+assignmentId+ " }) { entityId } } ";
			return params;
		}

		const onSubmit=()=>{
			const mutation = getMutationQuery();
			const req = [];
			let flag = false;
			const que = ServiceRegistry.get(XHRResolverService).execute(mutation).then(req => {
				
				let reqData= JSON.parse(req);
				let data= reqData.data;
				if(reqData.errors){
					ForumToaster.show({
						intent: Intent.DANGER,
						message: "Error while publishing assignment!!"
					});
				} else if(data['testAssignmentPublish']){
					ForumToaster.show({
						intent: Intent.SUCCESS,
						message: "Assignment published successfully!!"
					});
					flag = true;
				}
			 }).catch(err => {
				console.log(err);
			 });

			 req.push(que);
             Promise.all(req)
				.then((value) => {
					if (flag)
						onChange("assignmentStatus",1);
				})
				.catch((reason) => {
					console.log(reason)
					ForumToaster.show({
						intent: Intent.DANGER,
						message: "An error occurred!!"
					});
				});
		}

		const display = (edit && state.properties["assignmentStatus"] === 0) ? "block" : "none";
		
		return(
			
			<StyledDiv style={{display:display}}>
				<span> Once the assignment is published, questions cannot be added or removed from the assignment. Make sure you have added the questions you want to the assignment before publishing.</span>
				<br></br><ButtonView
					variant={ButtonVariant.PRIMARY}
					viewKey="assignmentForm.publish"
					onClick={onSubmit}
				>
					<Label k="assignmentForm.publishButton" v={"Publish"}/> 
				</ButtonView>
			</StyledDiv>
		)
	}
}

export const deleteButton: IDataFragment<IAssignmentFragmentProps> = {
	name: "Delete",
	label: {},
	component: ({ state, edit, assignmentId, onChange }) => {

		const getMutationQuery=()=>{
			let params:string = "mutation { testAssignmentDelete(params: { ";
			params = params + "id: "+assignmentId+ " }) { entityId } } ";
			return params;
		}

		const onSubmit=()=>{
			const mutation = getMutationQuery();
			const req = [];
			let flag = false;
			const que = ServiceRegistry.get(XHRResolverService).execute(mutation).then(req => {
				
				let reqData= JSON.parse(req);
				let data= reqData.data;
				if(reqData.errors){
					ForumToaster.show({
						intent: Intent.DANGER,
						message: "Error while deleting assignment!!"
					});
				} else if(data['testAssignmentDelete']){
					ForumToaster.show({
						intent: Intent.SUCCESS,
						message: "Assignment deleted successfully!!"
					});
					flag = true;
				}
			 }).catch(err => {
				console.log(err);
			 });

			 req.push(que);
             Promise.all(req)
				.then((value) => {
					if (flag)
						onChange("assignmentStatus",2);
				})
				.catch((reason) => {
					console.log(reason)
					ForumToaster.show({
						intent: Intent.DANGER,
						message: "An error occurred!!"
					});
				});
		}

		const display = (edit && state.properties["assignmentStatus"] === 1) ? "block" : "none";

		
		return(
			
			<StyledDiv style={{display:display}}>
				<span>Once the assignment is deleted, it will be removed for all users immediately. Any users working on the assignment will not be able to complete the assignment.</span>
				<br></br><ButtonView
					variant={ButtonVariant.PRIMARY}
					viewKey="assignmentForm.delete"
					onClick={onSubmit}
				>
					<Label k="assignmentForm.deleteButton" v={"Delete"}/> 
				</ButtonView>
			</StyledDiv>
		)
	}
}




// WEBPACK FOOTER //
// ./src/panels/testAssignment/fragments/displayFragments.tsx